"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
exports.default = (function (links) {
    links === null || links === void 0 ? void 0 : links.pressLinks.sort(function (a, b) { return (Date.parse(a.date) < Date.parse(b.date) ? 0 : -1); });
    var linkCards = links === null || links === void 0 ? void 0 : links.pressLinks.map(function (link, i) {
        var borderColor;
        var buttonText;
        if (link.type === 'news') {
            borderColor = 'chelsea-cucumber';
            buttonText = 'Read More';
        }
        else if (link.type === 'broadcast') {
            borderColor = 'koromiko';
            buttonText = 'Watch Now';
        }
        else {
            borderColor = 'cornflower-blue';
            buttonText = 'Read More';
        }
        return (React.createElement("div", { key: i, className: 'cell medium-6 large-4 flex-container' },
            React.createElement("div", { className: "padding-4 bordered text-center border-transparent-".concat(borderColor), style: { borderWidth: '19px' }, "data-equalizer-watch": true },
                React.createElement("div", null, link.date),
                React.createElement("img", { src: link.image, alt: "image ".concat(link.image) }),
                React.createElement("h4", { className: 'h6 margin-vertical-4' }, link.title),
                React.createElement("div", { className: 'font-lighter margin-vertical-4 text-gray' }, link.body),
                React.createElement("a", { className: "button padding-vertical-4 padding-horizontal-8 bg-".concat(borderColor), href: link.link, target: '_blank' }, buttonText))));
    });
    return (React.createElement("div", { className: 'grid-x grid-margin-x grid-margin-y padding-4 medium-padding-8 large-padding-12', "data-equalizer": true }, linkCards));
});
